<template>
  <div>
    <img src="../assets/zajebiste-logo.gif" alt="ZAJEBISTA-PIZZA.PL" />
  </div>

  <footer>
    <ul>
      <li>
        <a href="https://masnyjakob.online/">by masnyjakob.online</a>
      </li>
    </ul>
  </footer>

  <div class="main-container">
    <div class="pizza-grid" :style="{ '--grid-size': gridSize }">
      <img
        v-for="i in count"
        :key="i"
        :src="pizzaSrc"
        alt="pizza"
        :style="pizzaStyle"
      />
    </div>

    <div>
      <p><strong>Ilość zajebistych pizz:</strong></p>
      <button @click="updateCount(-1)">-</button>
      <span>{{ count }}</span>
      <button @click="updateCount(1)">+</button>
    </div>
    <div class="ingredients">
      <p class="ingredient">Mąka: {{ flour }}g</p>
      <p class="ingredient">Woda: {{ water }}ml</p>
      <p class="ingredient">
        Drożdże: {{ yeast }}g (instant - {{ dryYeast }}g)
      </p>
      <p class="ingredient">Sól: {{ salt }}g</p>
    </div>
  </div>
  <div class="recipe-container">
    <div class="recipe">
      <h1>- Przepis -</h1>

      <h3 id="przygotowanie-ciasta">
        <a href="#przygotowanie-ciasta">Przygotowanie ciasta</a>
      </h3>
      <ol>
        <li>Do dużego garnka wlej wodę (o temperaturze pokojowej).</li>
        <li>Dodaj 10% ({{ flour * 0.1 }}g) mąki i wymieszaj.</li>
        <li>Dodaj drożdże i wymieszaj.</li>
        <li>Dodaj sól i wymieszaj.</li>
        <li>
          Stopniowo dodawaj pozostałą mąkę ({{ flour * 0.9 }}g), mieszając, aż
          ciasto zacznie się formować.
        </li>
        <li class="tip">
          wskazówka: Możesz użyć sitka przesypując mąkę, żeby uniknąć grudek.
        </li>
        <li>
          Przełóż ciasto na blat posypany mąką i ugniataj przez około 10 minut,
          aż będzie gładkie i elastyczne.
        </li>
        <li>
          Przełóż ciasto z powrotem do garnka, przykryj mokrą szmatką i odstaw
          na 1-2 godziny w ciepłe miejsce.
        </li>
        <li>Przełóż ciasto do pojemnika i odłóż do lodówki na 24 godziny.</li>
        <li class="tip">
          wskazówka: możesz użyć {{ count }} mniejszych pojemników zamiast
          jednego dużego, żeby łatwiej formować kulki później. Dodatkowo,
          wysmaruj pojemniki oliwą z oliwek przed włożeniem do nich ciasta.
        </li>
        <li>Po 24 godzinach ciasto jest gotowe do użycia.</li>
      </ol>

      <h3 id="formowanie-kulek">
        <a href="#formowanie-kulek">Formowanie kulek</a>
      </h3>
      <ol>
        <li>3-4h przed jedzeniem wyjmij ciasto z lodówki.</li>
        <li class="tip">
          wskazówka: Teraz wyjmij też mozarellę, niech się odsącza z wody.
        </li>
        <li>
          Posyp stół i dłonie mąką (polecam samolinę), wyjmij kulkę z pojemnika
          i połóż na stole.
        </li>
        <li>
          Zacznij rozpłaszczać kulkę palcami, od środka na zewnątrz, zostawiając
          grubszy rant. Nie używaj wałka.
        </li>
        <li>
          Możesz zacząć delikatnie rozciągać placek na boki, używając palców i
          dłoni. Celuj w okrągły kształt i ok. 20-25cm średnicy.
        </li>
        <li>
          Kiedy placek jest w miarę rozciągnięty, możesz go podnieść, delikatnie
          rozciągać w powietrzu używając obu dłoni, a na koniec położyć go z
          powrotem na stole, do góry nogami.
        </li>
        <li>
          Ciasto powinno być prześwitujące, ale uważaj na dziury. Jeśli jakaś
          się pojawi, spoko, tylko ją zaklej xd.
        </li>
        <li>
          2 łyżki stołowe sosu, ser, oliwa i do pieca. I do pieca. I do pieca. I
          do pieca. I do pieca.
        </li>
      </ol>

      <h3 id="pieczenie-ferrari">
        <a href="#pieczenie-ferrari">Pieczenie - Ferrari</a>
      </h3>
      <ol>
        <li>Rozgrzej piec na max.</li>
        <li>Piecz 4-5 minut, doglądając brzegów.</li>
      </ol>

      <h3 id="pieczenie-normalny-piec">
        <a href="#pieczenie-normalny-piec">Pieczenie - normalny piec</a>
      </h3>
      <ol>
        <li>Rozgrzej piec na max.</li>
        <li>Pizzę daj jak najbliżej grzałki.</li>
        <li>Piecz 7-10 minut, doglądając brzegów.</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      count: 1,
      flour: 0,
      water: 0,
      yeast: 0,
      dryYeast: 0,
      salt: 0,
      pizzaSrc:
        "https://64.media.tumblr.com/1c73bb45e63fb1f7341143e58a869f80/tumblr_mhw4w4nT1f1qmurn4o1_500.gif",
    };
  },
  methods: {
    updateCount(change) {
      this.count = Math.max(1, this.count + change);
      this.calculate(this.count);
    },
    calculate(count) {
      this.flour = count * 125;
      this.water = Math.round((this.flour * 0.68) / 5) * 5;
      this.yeast = count * 0.5;
      this.dryYeast = Math.round(this.yeast * 0.3 * 10) / 10;
      this.salt = count * 4;
    },
  },
  mounted() {
    this.calculate(this.count);
  },
  computed: {
    gridSize() {
      return Math.ceil(Math.sqrt(this.count));
    },
    pizzaStyle() {
      return {
        width: "100%",
        height: "100%",
        objectFit: "contain",
      };
    },
  },
};
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
}
a {
  text-decoration: none;
}
a:link {
  color: unset;
}
a:visited {
  color: unset;
}
a:hover {
  color: unset;
}
button {
  margin: 5px;
  padding: 5px 10px;
  font-size: 16px;
}
span {
  font-size: 18px;
  margin: 0 10px;
}

ol {
  display: flex;
  flex-direction: column;
  padding: 0;
}

.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.ingredients {
  align-items: center;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 12px;

  margin: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fffdde;
  max-width: 600px;
  text-align: left;
  line-height: 1.8;
}

.ingredient {
  margin: 0;
  display: inline;
}

.recipe-container {
  display: flex;
  justify-content: center;
}

.recipe {
  margin: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  max-width: 600px;
  text-align: left;
  line-height: 1.8;

  h1 {
    text-align: center;
    margin-bottom: 20px;
  }
}

.tip {
  font-style: italic;
  color: #555;
  padding-left: 40px;
}

.pizza-grid {
  margin: auto;
  width: 300px;
  height: 300px;
  display: grid;
  grid-template-columns: repeat(var(--grid-size), 1fr);
  grid-template-rows: repeat(var(--grid-size), 1fr);
  gap: 2px;
}

.pizza-grid img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
